<script setup lang="ts">
  import { Text } from "@ui-kit";

  const { title, count } = defineProps<{
    title: string;
    count: number;
  }>();
</script>

<template>
  <div class="check-alarming-clear-item" :class="{ 'check-alarming-clear-item--error': count > 0 }">
    <Text font="body-regular-14" :color="count > 0 ? 'error' : 'primary'">
      {{ title }}
    </Text>
    <Text font="body-bold-18" :color="count > 0 ? 'error' : 'primary'">
      {{ count }}
    </Text>
  </div>
</template>

<style scoped>
  .check-alarming-clear-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    padding: 10px 16px;
    background-color: var(--sf-base-background-secondary);
  }

  .check-alarming-clear-item--error {
    background-color: var(--sf-base-background-error);
  }
</style>
